import EmptyImg from '@/_assets/icons/empty.svg';
import { Button } from '@/components/ui/button';
import { Link } from '@/i18n/navigation';
import { Center, Text, VStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

const EmptyStatus = () => {
  const t = useTranslations();
  return (
    <Center flexDir='column' gap='4' py='24'>
      <VStack>
        <Image src={EmptyImg} width={200} height={200} alt='cart' />
        <Text
          fontSize={{ base: 24, lg: 32 }}
          color={'#667085'}
          fontWeight={600}
        >
          {t('no_orders_yet')}
        </Text>
      </VStack>

      <Link href={'/'}>
        <Button
          bg='primary'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          size={{ base: 'lg', lg: 'xl' }}
          rounded={{ base: 'full', lg: '12px' }}
        >
          {t('choose_dish')}
        </Button>
      </Link>
    </Center>
  );
};

export default EmptyStatus;
